// Shared helpers for the catalog viewer: kind color mapping, date
// formatting, barcode selection, string capitalization. Colors are mapped
// to iOS system colors so the badges feel native on iPadOS.

import type { ItemDetail } from "../data/catalog.ts";

export function kindTone(kind: string): string {
  if (kind === "serialized_firearm") return "bg-[#1c1c1e]";
  if (kind === "serialized_other") return "bg-[#3a3a3c]";
  if (kind === "service") return "bg-[#5856d6]";
  if (kind === "fee") return "bg-[#8e8e93]";
  if (kind === "gift_card") return "bg-[#34c759]";
  if (kind === "class_seat") return "bg-[#ff9500]";
  if (kind === "kit") return "bg-[#af52de]";
  if (kind === "non_inventory") return "bg-[#8e8e93]";
  return "bg-[#007aff]"; // standard
}

export function formatDate(iso: string | null): string {
  if (!iso) return "—";
  try {
    const d = new Date(`${iso}T00:00:00`);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}

export function primaryBarcode(barcodes: ItemDetail["barcodes"]): string | null {
  const primary = barcodes.find((b) => b.isPrimary);
  if (primary) return primary.code;
  return barcodes[0]?.code ?? null;
}

export function capitalize(s: string): string {
  return s.length === 0 ? s : s[0]?.toUpperCase() + s.slice(1);
}
